import { HTTPError } from "../clients/httpError";
import { getBearerToken } from "../clients/internalClient";
import { API_BASE_URL } from "../env";


export interface CallProps {
  prompt: string, 
  primingMessages: {
    kind: 'user' | 'ai',
    text: string
  },
  attachments?: Attachment[],
  threadId: string, 
  agent?: string, 
  signal?: any,
  onDone?: any, 
  onError?: any,
  onEvent?: any
}

export interface Attachment {
  text: string,
  content: string,
}

export async function agentStream({onDone, onError, ...props}: CallProps) {  
  try {
    await agentStreamImpl(props);
  } catch (e) {
    if (e.name === 'AbortError') {
      console.log("aborted...")
    } else {
      console.error(e)
      onError?.(e)  
    }
  } finally {
    onDone?.()
  }
}

async function agentStreamImpl({signal, onEvent, agent, ...props}: Partial<CallProps>) {  

  function processEvent(line) {
    line = line.trim()
    if (!line) {
      return;
    }
    try {
      const event = JSON.parse(line);
      onEvent?.(event)
    } catch(e) {
      console.error("cannot parse event", line, e)
    }
  }

  const authToken = await getBearerToken()
  const response = await fetch(API_BASE_URL + '/api/ai/run', {
    method: 'POST',
    signal,
    body: JSON.stringify({
      ...props,
      agentId: agent
    }),
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${authToken}`
    }
  });

  if (!response.ok) {   
    let details = null;
    if (response.status < 500) {
      details = await ( response.status === 402 ? response.json() : response.text() )
    } 
    throw new HTTPError(response.statusText, response.status, details);
  }

  const reader = response.body?.getReader();
  const decoder = new TextDecoder('utf-8');

  if (!reader) {
    throw new Error("invalid response")
  }

  let partialLine = ''; 

  while (true) {
    const { value, done } = await reader.read();
    if (done) break;

    const chunk = decoder.decode(value, { stream: true });
    partialLine += chunk;

    const lines = partialLine.split('\n');
    partialLine = lines.pop() || '';

    for (const line of lines) {      
      processEvent(line)
    }
  }

  processEvent(partialLine)
}


